export default __webpack_public_path__ + "static/media/unn.5b605914.png";